import { render, staticRenderFns } from "./ClientInfoModal.vue?vue&type=template&id=1584ef52&"
import script from "./ClientInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClientInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports